import axiosInstance from "../Middleware/interceptor";
import { toast } from "react-toastify";
import axios from 'axios';

export const postApi = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.post(`${url}`, data, config);
    
    // Check if it's a network error from interceptor
    if (response?.data?.isNetworkError) {
      toast.error(response.data.msg);
    } else if (response?.data?.success === false && response?.data?.msg) {
      // Optional: show other API-level error messages
      // toast.error(response.data.msg);
    }

    return response?.data;
  } catch (error) {
    if (axios.isCancel?.(error) || error.name === 'CanceledError' || error.name === 'AbortError') {
      // console.log('Request cancelled');
    } else {
      const errorMsg = error.response?.data?.message || error.message || 'An unexpected error occurred';
      toast.error(`Error: ${errorMsg}`);
    }
    throw error;
  }
};

export const getApi = async (url, options = {}) => {
  try {
    const response = await axiosInstance.get(url, {
      signal: options.signal,
    });

    if (response?.data?.isNetworkError) {
      toast.error(response.data.msg);
    }

    return response?.data;
  } catch (error) {
    if (axios.isCancel?.(error) || error.name === 'CanceledError' || error.name === 'AbortError') {
      console.log('Request cancelled:', error.message);
    } else {
      console.error('API Error:', error);
    }
    throw error;
  }
};

export const putApi = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.put(`${url}`, data, config);
    if (response?.data?.isNetworkError) {
      toast.error(response.data.msg);
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteApi = async (url, config = {}) => {
  try {
    const response = await axiosInstance.delete(`${url}`, config);
    if (response?.data?.isNetworkError) {
      toast.error(response.data.msg);
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const patchApi = async (url, data, config = {}) => {
  try {
    const response = await axiosInstance.patch(`${url}`, data, config);
    if (response?.data?.isNetworkError) {
      toast.error(response.data.msg);
    }
    return response?.data;
  } catch (error) {
    throw error;
  }
};
